export const SIGNATURE_GREEN = '#0d9487';
